export const AutomationTagHookPrefix = 'qa-hook';
